import ApplicationAdapter, { projectChildMixin } from "./application";

export default class NetworkCircuitAdapter extends ApplicationAdapter.extend(projectChildMixin) {
  uriSuffix = "network-circuits";
}
